import * as actionTypes from '../actions/actionTypes';

export default function headerdetailsReducer(state = {}, action) {
  switch(action.type){
      case actionTypes.SET_FOOTER_DATA: {
        let  {termsCondition, privacyPolicy, cookie}= action;
        return {termsCondition, privacyPolicy, cookie};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/footerDetailsReducer.js